module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-6-54c24897004ddbac1a55059520c0857f.svg";